/**
 * @requires store js (https://github.com/marcuswestin/store.js/)
 */
jQuery(document).ready(function($) {
    var sessionName = 'WholsaleApp';

    $.fn.close = function() {
        var $widget = $(this);
        
        $widget.data('closed', true);
        
        var session = store.get(sessionName) || {};
        var widgets = session.widgets || {};
        var closed = widgets.closed || [];
        
        var id = $widget.data('storeId') || $widget.attr('id') || 'default';
        var widget = widgets[id] || { closed: false };
        
        $widget.find('.widget-content, .widget-footer').stop().slideUp(function() {
            if ( closed.indexOf(id) == -1 ) {
                closed.push(id);
            }
            
            widget.closed = true;
            
            widgets[id] = widget;
            widgets.closed = closed;
            session.widgets = widgets;
            
            store.set(sessionName, session);
            
            $widget.find('.js-widget-toggle i').removeClass('icon-minus-squared').addClass('icon-plus-squared');
            $widget.trigger('closed');
            
            $(document).trigger('widget.closed', $widget);
        });
    };
    
    $.fn.open = function() {
        var $widget = $(this);
        
        $widget.data('closed', false);

        var session = store.get(sessionName) || {};
        var widgets = session.widgets || {};
        var closed = widgets.closed || [];
        
        var id = $widget.data('storeId') || 'default';
        var widget = widgets[id] || { closed: false };
        
        $widget.find('.widget-content, .widget-footer').stop().slideDown(function() {
            widget.closed = false;
            var index = closed.indexOf(id);
            if (index > -1) {
                closed.splice(index, 1);
            }
            
            //closed.remove(id);
            
            widgets[id] = widget;
            widgets.closed = closed;
            session.widgets = widgets;
            
            store.set(sessionName, session);
            
            $widget.find('.js-widget-toggle i').removeClass('icon-plus-squared').addClass('icon-minus-squared');
            $widget.trigger('opened');
    
            $(document).trigger('widget.opened', $widget);
        });
    };
    
    $.fn.fullscreen = function() {
        var $widget = $(this);
       
        $widget.toggleClass('fullscreen');
       
        if ( $widget.hasClass('fullscreen') ) {
            var height = $widget.height() - ( $widget.find('.widget-title').height() + $widget.find('.widget-footer').height() + 10 );
            $widget.find('.widget-content').css('height', height);
            
            $('body').css('overflow', 'hidden');
        } else {
            $widget.find('.widget-content').css('height', 'auto');
            $('body').css('overflow', 'auto');
        }
       
        $widget.find('.js-widget-fullscreen i').toggleClass('icon-fullscreen icon-resize-small');
        $widget.trigger('fullscreen');
        
        $(document).trigger('widget.fullscreen', $widget);
    };
    
    // init all widgets
    var session = store.get(sessionName) || {};
    var widgets = session.widgets || {};
    var closed = widgets.closed || [];
    
    closed.forEach(function(key) {
        $('.widget-box[data-store-id="' + key + '"]').close();
    });

    // Bindings for widget auto-close
    // On mouse leave a widget area then close widget
    // On mouse enter into a widget area open widget
    $(document).on('mouseleave', '.widget-box.js-auto-close', function() {
        $(this).trigger('widget.close');
    }).on('mouseenter', '.widget-box.js-auto-close', function() {
        $(this).trigger('widget.open');
    });
    
    // Collapse event listener
    $(document).on('click', '.widget-box .js-widget-toggle', function(e) {
        var $widget = $(this).closest('.widget-box');

        // when close/open button is clicked
        // remove the auto-close functionality
        $widget.removeClass('js-auto-close');

        if ( $widget.data('closed') ) {
            $widget.trigger('widget.open');
        } else {
            $widget.trigger('widget.close');
        }
        
        e.preventDefault();
    });
    
    // Fullscreen event listener
    $(document).on('click', '.widget-box .js-widget-fullscreen', function(e) {
        var $widget = $(this).closest('.widget-box');
        
        $widget.fullscreen();
        
        e.preventDefault();
    });

    // Close event listener
    $(document).on('widget.close', '.widget-box', function(e) {
        $(this).close();
    });

    // Open event listener
    $(document).on('widget.open', '.widget-box', function(e) {
        $(this).open();
    });
});
